var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.value)?_c('base-link',_vm._g({attrs:{"href":_vm.filtered_value}},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }